export const filterMixin = {
  watch: {
    options: {
      handler() {
        this.applyFilter({filters: this.buildFilterString()})
      },
    },
    deep: true,
  },
  data: () => {
    return {
      filterVisibility: false,
    }
  },
  methods: {
    buildFilterString(additionalFilter) {
      if (!this.filters) {
        return ''
      }
      let filterString = ''

      this.filters.forEach((element) => {
        if (element.value) {
          filterString =
            filterString + '&' + element.property + '=' + element.value
        }
        if (element.valuefrom) {
          filterString =
            filterString + '&' + element.property + 'from=' + element.valuefrom
        }
        if (element.valueto) {
          filterString =
            filterString + '&' + element.property + 'to=' + element.valueto
        }
      })
      if (additionalFilter) {
        filterString += additionalFilter
      }

      return filterString
    },
    resetFilter() {
      for (let i = 0; i < this.filters.length; i++) {
        if (this.filters[i]) {
          this.filters[i].value = null
        }
      }
    },
  },
}
